import gql from 'graphql-tag';

export const ADD_CALENDAR_VIEW = gql`
  mutation SaveCalendarViewConfiguration($input: AddCalendarViewInput!) {
    dealActivity {
      result: addCalendarView(input: $input) {
        error
        success
        entity {
          id
          name
          color
          owner {
            id
            fullName
          }
        }
      }
    }
  }
`;
